import React, { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { useAuth } from '../contexts/AuthContext';
import './Pages.css';

export const Login: React.FC = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const registrationPending = Boolean((location.state as any)?.registrationPending);
  const verificationEmailSent = (location.state as any)?.verificationEmailSent !== false;
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(email, password);
      // Redireciona para a página que tentou acessar ou para o dashboard
      const from = (location.state as any)?.from?.pathname || '/dashboard';
      navigate(from, { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Não foi possível entrar. Verifique email e senha.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ns-login">
      <div className="ns-login-panel">
        <div className="ns-login-header">
          <div className="ns-login-logo">
            <span className="mark">NS</span>
            <span className="text">NutriSync</span>
          </div>
          <p>Painel web para nutricionista</p>
        </div>
        <form className="ns-login-form" onSubmit={handleSubmit}>
          {registrationPending && verificationEmailSent && <p className="ns-login-notice">Conta criada. Confirme seu e-mail pelo link enviado antes de entrar.</p>}
          {registrationPending && !verificationEmailSent && <p className="ns-login-error">Sua conta foi criada, mas o servidor não conseguiu enviar o link de confirmação. Entre em contato com o suporte para concluir a ativação.</p>}
          <label className="ns-field">
            <span>Email</span>
            <input
              className="ns-input"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="seuemail@clinica.com"
            />
          </label>
          <label className="ns-field">
            <span>Senha</span>
            <input
              className="ns-input"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
            />
          </label>
          {error && <p className="ns-login-error">{error}</p>}
          <div className="ns-form-actions">
            <Button type="submit" disabled={loading}>
              {loading ? 'Entrando...' : 'Entrar'}
            </Button>
          </div>
        </form>
        <p className="ns-login-footer"><Link to="/forgot-password">Esqueci minha senha</Link></p>
        <p className="ns-login-footer">
          A sessão é validada no servidor NutriSync.
        </p>
        <p className="ns-login-footer">
          <Link to="/">Voltar para apresentação</Link>
        </p>
      </div>
    </div>
  );
};

